<template>
  <div>
    <common-dialog
      ref="dialog"
      width="500px"
      show-save-button
      title="保存查询方案"
      id-key="QueryPlanId"
      in-dialog
      :data="data"
      :form-rules="rules"
      :save-func="api.save"
      @create-opened="onCreateOpened"
      @closed="data.Dts=[]"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-form-item label="方案名称" prop="QueryPlanName">
          <el-input v-model="data.QueryPlanName" :placeholder="'请输入方案名称'"></el-input>
        </el-form-item>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        QueryPlanId: 0,
        QueryPlanName: "",
        TeacherId: 0,
        Dts: [],
      },
      api: require("@/api/gd/queryplan").default,
      rules: {
        QueryPlanName: [{ required: true, message: "方案名称不能为空" }],
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened(data) {
      console.log("open", data, this.$store.state.user.teacherId);
      this.data = { ...data };
      if(data.QueryPlanId == 0) this.data.QueryPlanName = "";
    },
  },
};
</script>